<template>
	<div class="bg-color-granite pb-10">
		<div class="d-flex justify-center align-center w-100 position-relative">
			<v-img class="w-100 h-100"			
				:height="199"
				aspect-ratio="16/9"
				src="https://dellpartnerincentives.com/siteassets/Images/HomePartner/Banner/bgRISE2.jpg"
			></v-img>
			<div class="position-absolute page-header">
				<h1><LanguagePlaceholder default-text="Eligible Products" /></h1>
			</div>		
 		</div>

        <div class="bg-color-granite w-100 h-100">
            <div class="bg-color-quartz w-100 h-100 my-2">
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 pt-3 tx-color-white" :class="{'bg-color-teal-900': systemStore.systemView === 'Distributor', 'bg-color-dell-blue': systemStore.systemView !== 'Distributor'}" >
                    <v-col cols="9" class="d-flex flex-column justify-start w-100 pa-0 py-8 tx-font-normal tx-font-size20">  
                        <v-row class="mb-1">
                            <h4>
                                <LanguagePlaceholder is-html
                                default-text="Earn competitive '$ per box' rewards on qualifying purchases." />
                            </h4>
                        </v-row>
                        <v-row class="mb-1">
                            <LanguagePlaceholder is-html
                            default-text="Please note that not all products contribute toward the RISE Rewards Multipliers, which are unlocked once defined unit thresholds are met." />                           
                        </v-row>
                        <v-row v-if="systemStore.systemView === 'Distributor'" class="mb-3">
                            <LanguagePlaceholder is-html
                            default-text="For a detailed breakdown of the eligible products that partners can earn on, view the table below or, <a href='https://dellpartnerincentives.com/resources/RISE%20Eligible%20Products%20List.pdf' class='dell-white'>click here</a>" />                      
                        </v-row>
                        <v-row v-else class="mb-3">
                            <LanguagePlaceholder is-html
                            default-text="For a detailed breakdown of the eligible products that you can earn on view the table below or, <a href='https://dellpartnerincentives.com/resources/RISE%20Eligible%20Products%20List.pdf' class='dell-white'>click here</a>" />                      
                        </v-row>
                        <v-row class="mb-1">
                            <LanguagePlaceholder is-html
                            default-text="<b style='font-size: 30px; font-weight: bolder'>NEW!</b> RISE e-voucher rewards can now be spent on all Dell Technologies products, excluding those containing AMD and Qualcomm processors" />
                        </v-row>
                        <v-row v-if="systemStore.systemView === 'Distributor'" class="mb-1">
                            <LanguagePlaceholder is-html
                            default-text="For a detailed breakdown of the Dell Technologies products that partners can spend their e-voucher rewards on, view the table below or, <a href='https://dellpartnerincentives.com/resources/RISE%20Eligible%20Products%20List.pdf' class='dell-white'>click here</a>" />
                        </v-row>
                        <v-row v-else class="mb-1">
                            <LanguagePlaceholder is-html
                            default-text="For a detailed breakdown of the Dell Technologies products that you can spend your e-voucher rewards view the table below or, <a href='https://dellpartnerincentives.com/resources/RISE%20Eligible%20Products%20List.pdf' class='dell-white'>click here</a>" />
                        </v-row>
                    </v-col>
                </v-row>
            </div>
        </div>

        <div class="bg-color-granite w-auto h-100 my-2 mx-10" >
            <v-row no-gutters class="d-flex justify-center w-100 pa-0">
                <!-- <v-col cols="1" class="bg-color-quartz"></v-col> -->
                <v-col cols="5" class="d-flex justify-start w-100 pa-0 py-5 tx-font-bold bg-color-quartz">  
                    <v-container>

                        <div class="bg-color-granite w-100 my-5">
                            <div class="bg-color-quartz w-100 my-2">
                                <h2>
                                    Products that you can <b> EARN </b> rewards on
                                </h2>
                            </div>
                        </div>

                        <v-expansion-panels v-model="panel" tile variant="accordion" class="my-3">
                            <v-expansion-panel>

                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}">
                                        <LanguagePlaceholder default-text="PCS+ DISPLAYS+PERIPHERALS" />
                                    </v-expansion-panel-title>
                            

                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <LanguagePlaceholder is-html default-text="Rewards Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD and Qualcomm-powered configurations are not eligible on PC purchases</b>)</p>" /> 
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact">
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="PCs+ Displays+Peripherals (SnS: Stock & Sell Only)" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="$ Rewards Per Box" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="Counts Towards  Rewards Multiplier" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts.pcDisplayPeripheralProducts">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>

                            <v-expansion-panel>
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}">
                                        <LanguagePlaceholder default-text="Server+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >                         
                                                <LanguagePlaceholder is-html default-text="Rewards Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD is not eligible on Server purchases</b>)</p>" />                                  
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact">
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="Server+ SNS (Stock and Sell all) & B2B (Smart selection only)" />
                                                                
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="$ Rewards Per Box" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="Counts Towards  Rewards Multiplier" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr style="background-color: #CBEEFF;">
                                                            <td>
                                                                <LanguagePlaceholder default-text="Stock & Sell and Back to Back" />
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr v-for="i in eligibleProducts.serverPlusB2BProducts">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr style="background-color: #CBEEFF;">
                                                            <td>
                                                                <LanguagePlaceholder default-text="Stock & Sell Only" />
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr v-for="i in eligibleProducts.serverPlusSnSProducts">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                        <tr style="background-color: #CBEEFF;">
                                                            <td>
                                                                <LanguagePlaceholder default-text="Smart Selection Only" />
                                                                
                                                            </td>
                                                            <td></td>
                                                            <td></td>
                                                        </tr>
                                                        <tr v-for="i in eligibleProducts.serverPlusSmartSelectionOnlyProducts">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>

                            </v-expansion-panel>

                            <v-expansion-panel>
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}">
                                        <LanguagePlaceholder default-text="Storage+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <LanguagePlaceholder default-text="Rewards Overview" />
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact">
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="Storage+ (Eligible Back to Back (B2B) Smart Selection Offers)" />
                                                                
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="$ Rewards Per Box" />
                                                                
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="Counts Towards  Rewards Multiplier" />
                                                                
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts.storagePlusProducts">
                                                            <td>
                                                            {{ i.productDescription }}
                                                            </td>
                                                            <td>
                                                                {{ $filters.currencyUSD(i.rewardsPerBox) }}
                                                            </td>
                                                            <td>
                                                                {{ i.countTowardsMultiplier === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>
                        </v-expansion-panels>
                        
                        </v-container>
                </v-col>
                <v-col cols="6" class="d-flex justify-start w-100 pa-0 py-5 tx-font-bold bg-color-quartz">
                    <v-container>
                        <div class="bg-color-granite w-100 my-5">
                            <div class="bg-color-quartz w-100 my-2">
                                <h2>
                                    Products that you can <b> SPEND </b> rewards on
                                </h2>
                            </div>
                        </div>

                        <v-expansion-panels v-model="panel2" tile variant="accordion">
                            <v-expansion-panel>

                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}">
                                        <LanguagePlaceholder default-text="PCS+ DISPLAYS+PERIPHERALS" />
                                    </v-expansion-panel-title>
                            

                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <LanguagePlaceholder is-html default-text="Product Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD and Qualcomm-powered configurations are not eligible on PC purchases</b>)</p>" /> 
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact">
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="Product Type" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="Transaction Type" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="Products that you can <b>SPEND</b> rewards on" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts_Spend_PCS.items">
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.productType }}
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.transactionType }}
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.canSpend === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>

                             <v-expansion-panel>
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}">
                                        <LanguagePlaceholder default-text="Server+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >                         
                                                <LanguagePlaceholder is-html default-text="Product Overview <p style=&quot;font-size: 70%&quot;>(<b>AMD is not eligible on Server purchases</b>)</p>" />                                  
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact">
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="Product Type" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="Transaction Type" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="Products that you can <b>SPEND</b> rewards on" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts_Spend_Server.items">
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                            {{ i.productType }}
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.transactionType }}
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.canSpend === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>

                            </v-expansion-panel>

                            <v-expansion-panel>
                                
                                    <v-expansion-panel-title :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB', color: 'white'}">
                                        <LanguagePlaceholder default-text="Storage+" />
                                        </v-expansion-panel-title>
                                    <v-expansion-panel-text class="no-padding innerExPan">

                                        <v-card tile flat class="pa-0">
                                            <v-card-title 
                                            class="text-white"
                                            :style="{'background-color': systemStore.systemView === 'Distributor' ? '#00796B' : '#0672CB'}"
                                            color="white"
                                            lines="one"
                                            >
                                                <LanguagePlaceholder default-text="Product Overview" />
                                            </v-card-title>
                                            <v-card-text class="pa-0">
                                                <v-table density="compact">
                                                    <thead>
                                                        <tr :style="{'background-color': systemStore.systemView === 'Distributor' ? '#004D40' : '#0672CB', color: 'white'}">
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="Product Type" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder default-text="Transaction Type" />
                                                            </th>
                                                            <th class="text-left">
                                                                <LanguagePlaceholder is-html default-text="Products that you can <b>SPEND</b> rewards on" />
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="i in eligibleProducts_Spend_Storage.items">
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.productType }}
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.transactionType }}
                                                            </td>
                                                            <td :style="{ color: i.canSpend===true ? '#000000' : '#FF0000', fontWeight: i.canSpend===true ? 'normal' : 'bold' }">
                                                                {{ i.canSpend === true ? 'Yes' : 'No' }}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </v-card-text>
                                        </v-card>
                                    </v-expansion-panel-text>
                                

                            </v-expansion-panel>

                        </v-expansion-panels>
                    </v-container>
                </v-col>
                <!-- <v-col cols="1" class="bg-color-quartz"></v-col> -->
            </v-row>
        </div>

        <div class="bg-color-granite w-100 h-100">
            
            <div class="bg-color-cobalt tx-color-white w-100 h-100 mt-2" >
                <v-row no-gutters class="d-flex justify-center w-100 pa-0 py-10 tx-color-white" :class="{'bg-color-teal-900': systemStore.systemView === 'Distributor', 'bg-color-cobalt': systemStore.systemView !== 'Distributor'}">
                    <v-col cols="9" class="d-flex flex-column justify-start w-100 pa-0 tx-font-normal tx-font-size14">  
                        <p class="font-italic">
                            <LanguagePlaceholder default-text="Please be advised that products containing AMD and Qualcomm processors are excluded from any rewards or incentives mentioned on this page." />                                    
                        </p>
                        <br>
                        <p>
                            <LanguagePlaceholder is-html default-text="* Only available in CEEMETA regions (see full lists below).  Click <a href='https://dellpartnerincentives.com/resources/Dell RISE Eligible Products_CEEMETA Displays.pdf' target='_blank' class='dell-white'>here</a> for the Displays List." />                                    
                        </p>
                        <br>
                        <p>
                            Albania, Algeria, Angola, Armenia, Azerbaijan, Bahrain, Benin, Bosnia-Herzegovina, Botswana, Bulgaria, Burkina Faso, Burundi, Cameroon, Cape Verde, Central African Republic, Chad, Comoros, Congo, Cote d'Ivoire, Croatia, Czech Republic, Democratic Rep of the Congo, Djibouti, Egypt, Equatorial Guinea, Eritrea, Ethiopia, French Guiana, French Polynesia, Gabon, Gambia, Georgia, Ghana, Greece, Guadeloupe, Guinea, Guinea Bissau, Hungary, Iraq, Jordan, Kazakhstan, Kenya, Kosovo, Kuwait, Kyrgyzstan, Lebanon, Lesotho, Liberia, Libya, Macedonia, Madagascar, Malawi, Mali, Martinique, Mauritania, Mauritius, Mayotte, Moldova, Montenegro, Morocco, Mozambique, Namibia, New Caledonia, Niger, Nigeria, Oman, Poland, Qatar, Reunion, Romania, Randa, Saudi Arabia, Senegal, Serbia, Seychelles, Sierra Leone, Slovakia, Slovenia, Somalia, South Africa, Swaziland, Tajikistan, Tanzania, The French Southern Territories, Togo, Tunisia, Turkey, Turkmenistan, Uganda, Ukraine, United Arab , rates, Uzbekistan, Yemen, Zambia, Zimbabwe.
                        </p>           
                    </v-col>
                </v-row>
            </div>     
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useSystemStore } from '@/stores/system'
import LanguagePlaceholder from '@/components/LanguagePlaceholder.vue'

const systemStore = useSystemStore()

const eligibleProducts = ref({})

const eligibleProducts_Spend_PCS = ref(
{
    items: [
        { productType: 'Alienware', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Desktops/Inspiron/Vostro', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Laptops/Inspiron/Vostro', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Premium Desktops/XPS', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Premium Laptops/XPS', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Desktops/OptiPlex', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Laptops/Latitude', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Max Desktops/Precision Workstation', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Dell Pro Max Laptops/Precision Workstation', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Displays', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Client Peripherals', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Docking Stations', transactionType: 'SNS Only', canSpend: true },
        { productType: 'AMD & Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})

const eligibleProducts_Spend_Server = ref(
{
    items: [
        { productType: 'Enterprise Peripherals', transactionType: 'SNS Only', canSpend: true },
        { productType: 'Networking', transactionType: 'SNS Only', canSpend: true },
        { productType: 'ROK', transactionType: 'SNS Only', canSpend: true },
        { productType: 'All Servers', transactionType: 'SNS & B2B', canSpend: true },
        { productType: 'AMD & Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})

const eligibleProducts_Spend_Storage = ref(
{
    items: [
        { productType: 'All Storage', transactionType: 'SNS & B2B', canSpend: true },
        { productType: 'AMD & Qualcomm', transactionType: 'Excluded', canSpend: false }
    ]
})



onMounted(() => {
  systemStore.getEligibleProducts().then(result => {
      if (result.success === true) {
          eligibleProducts.value = result
      } else {
          systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
      }
  }).catch(error => {
      systemStore.showMessage('Error retrieving data, please try again or contact support for assistance.', { color: 'error' })
  })

})

const clickDownloadSKUListForCodes = () => {
  systemStore.getFile('FY25Q3 SKU LIST for Codes_WEBFINAL.pdf', 'files').then(res => {
      if (res.success === true) {
          systemStore.openUrl(res.fileUrl)
      }
  }).catch(error => {
      console.log(error)
  })
}

const panel = ref(0)

const panel2 = ref(0)

</script>

<style scoped>

</style>